import React from 'react';
import { PulsingDot } from '@fourthwall/components';
import { pluralize } from '@fourthwall/utils/dist/string';
import { useActiveVisitors } from './hooks/useActiveVisitors';
export const ActiveVisitors = () => {
    const { visitorsCount, available } = useActiveVisitors();
    if (!available) {
        return null;
    }
    return React.createElement(PulsingDot, { label: `${visitorsCount} live ${pluralize(visitorsCount, 'visitor')}` });
};
